// @flow

import type {Language, PreviousExport, ScheduledExport, ExportsSortBy, TabDataFlags} from '@/types'

import React, {Component} from 'react'
import {connect} from 'react-redux'
import {mergeAll} from 'ramda'
import {appActions, appSelectors, portfoliosSelectors, portfoliosActions, uiActions} from '@/store'

import Section from '@/elements/section'
import PreviousExports from './previous-exports'
import ScheduledExports from './scheduled-exports'
import NewExportButton from './new-export-button'
import {isAnyTabDataLoaded} from '@/views/util'
import RefreshButton from './refresh-button'

type Props = {
  activePortfolioPreviousExports: Array<PreviousExport>,
  activePortfolioScheduledExports: Array<ScheduledExport>,
  getPortfolioExportAttachment: (PreviousExport) => void,
  changeActivePortfolio: (number) => void,
  l: Language,
  setExportsPageNumber: (number, string) => void,
  setExportsSortOptions: (ExportsSortBy, string) => void,
  fetchExports: (string) => void,
  tabDataFlags: TabDataFlags,
  fetchExportsTabInitialData: () => void,
  fetchCommonTabsData: () => void,
  isLoading: boolean,
  activePortfolioId: number,
}

const fetchExportsSortBy = (props) => (sortBy: ExportsSortBy, type: string) => {
  props.setExportsPageNumber(0, type)
  props.setExportsSortOptions(sortBy, type)
  props.fetchExports(type)
}

const pageChange = (props) => (type: string) => (pageNumber: number) => {
  props.setExportsPageNumber(pageNumber - 1, type)
  props.fetchExports(type)
}

const checkAndFetchData = (props) => {
  // call apis to fetch this tab data
  if (!props.tabDataFlags.isExportsDataLoaded && !props.isLoading) {
    // fetch common tab data if no tab is loaded yet
    if (!isAnyTabDataLoaded(props.tabDataFlags)) {
      props.fetchCommonTabsData()
    }
    // fetch this tab data
    props.fetchExportsTabInitialData()
    // change portfolio if prev portfolio is All Portfolios
    if (props.activePortfolioId === 0) {
      props.changeActivePortfolio(props.activePortfolioId)
    }
  }
}

export class RawExportsPage extends Component<Props> {
  render () {
    const {props} = this
    return (
      <div className='exports-section'>
        <Section header={props.l('Exports')}>
          <div className="header-button pull-right">
            <RefreshButton/>
            <NewExportButton/>
          </div>
          <div className="row">
            <div className="col-xs-6">
              <PreviousExports exports={props.activePortfolioPreviousExports}
                getAttachment={props.getPortfolioExportAttachment}
                sortBy={fetchExportsSortBy(props)}
                pageChange={pageChange(props)}
              />
            </div>
            <div className="col-xs-6">
              <ScheduledExports exports={props.activePortfolioScheduledExports}
                sortBy={fetchExportsSortBy(props)}
                pageChange={pageChange(props)}
              />
            </div>
          </div>
        </Section>
      </div>
    )
  }

  componentDidMount = () => {
    checkAndFetchData(this.props)
  }

  componentWillReceiveProps = (nextProps: Props) => {
    checkAndFetchData(nextProps)
  }
}

const mapStateToProps = (state) => ({
  activePortfolioPreviousExports:
    portfoliosSelectors.getActivePortfolioPreviousExports(state),
  activePortfolioScheduledExports:
    portfoliosSelectors.getActivePortfolioScheduledExports(state),
  l: appSelectors.getL(state),
  tabDataFlags: state.app.tabDataFlags,
  isLoading: state.app.showAppLoader,
  activePortfolioId: state.app.activePortfolioId,
})

export default connect(
  mapStateToProps,
  mergeAll([appActions, portfoliosActions, uiActions]),
)(RawExportsPage)



// WEBPACK FOOTER //
// ./src/views/exports-page/index.js